import React from "react";

/**
 * Renders an unsuitable icon with the given class.
 *
 * @param {string} cls - The class for the icon
 * @return {JSX.Element} The SVG icon element
 */
export const UnsuitableIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      className={cls}
    >
      <path
        d="M11.9147 13.0698V8.21261C11.9147 7.76737 12.2899 7.40309 12.7485 7.40309C13.2071 7.40309 13.5823 7.76737 13.5823 8.21261V13.0698C13.5823 13.515 13.2071 13.8793 12.7485 13.8793C12.2899 13.8793 11.9147 13.515 11.9147 13.0698ZM12.7485 15.2427C12.0565 15.2427 11.4978 15.7851 11.4978 16.457C11.4978 17.1289 12.0565 17.6713 12.7485 17.6713C13.4406 17.6713 13.9992 17.1289 13.9992 16.457C13.9992 15.7851 13.4406 15.2427 12.7485 15.2427ZM22.4039 18.6393C21.8202 19.7321 20.5945 20.3555 19.0604 20.3555H6.44505C4.90253 20.3555 3.68519 19.7321 3.10153 18.6393C2.50954 17.5383 2.6763 16.1298 3.51843 14.9478L10.2221 4.65071C10.8141 3.82499 11.748 3.35547 12.7485 3.35547C13.7491 3.35547 14.6829 3.82499 15.2499 4.62642L21.987 14.964C22.8291 16.1459 22.9875 17.5464 22.3955 18.6393H22.4039ZM20.6112 15.8707C20.6112 15.8707 20.5945 15.8545 20.5945 15.8383L13.8658 5.5169C13.624 5.18499 13.2071 4.97452 12.7485 4.97452C12.2899 4.97452 11.873 5.18499 11.6146 5.54928L4.90253 15.8383C4.38557 16.5507 4.26884 17.3278 4.56901 17.8864C4.86084 18.4369 5.52787 18.7364 6.43671 18.7364H19.0437C19.9525 18.7364 20.6196 18.4369 20.9114 17.8864C21.2115 17.3278 21.0948 16.5507 20.6029 15.8707H20.6112Z"
        fill="currentColor"
      />
    </svg>
  );
};
